import { render } from "./StratesCategory.vue?vue&type=template&id=34b8f880"
import script from "./StratesCategory.vue?vue&type=script&lang=js"
export * from "./StratesCategory.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__